// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function PasswordInput(props) {
  var value = props.value;
  var match = React.useState(function () {
        return false;
      });
  var setShowPassword = match[1];
  var showPassword = match[0];
  var tmp = value === "" ? null : JsxRuntime.jsx("button", {
          children: showPassword ? "Hide" : "Show",
          className: "font-semibold text-gray-800 absolute right-3 bottom-2.5",
          type: "button",
          onClick: (function (param) {
              setShowPassword(function (current) {
                    return !current;
                  });
            })
        });
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Form__Input.make, {
                      labelText: "Password",
                      type: showPassword ? "text" : "password",
                      onChange: props.onChange,
                      onBlur: props.onBlur,
                      status: props.status,
                      value: value
                    }),
                tmp
              ],
              className: "relative"
            });
}

var make = PasswordInput;

exports.make = make;
/* react Not a pure module */
